import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { ChatDots, JournalText, Search } from 'react-bootstrap-icons';
import MeetingNotes from './MeetingNotes';
import PersonalNotes from './PersonalNotes';
import ResearchNotes from './ResearchNotes';

const Notes = ({ activeProfileId }) => {
    const [activeSubTab, setActiveSubTab] = useState('meeting');

    return (
        <div className="notes-container">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Notes</h4>
            </div>

            <Nav variant="tabs" className="mb-4">
                <Nav.Item>
                    <Nav.Link 
                        active={activeSubTab === 'meeting'} 
                        onClick={() => setActiveSubTab('meeting')}
                    >
                        <ChatDots className="me-2" />
                        Meeting Notes
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link 
                        active={activeSubTab === 'personal'} 
                        onClick={() => setActiveSubTab('personal')}
                    >
                        <JournalText className="me-2" />
                        Personal Notes
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link 
                        active={activeSubTab === 'research'} 
                        onClick={() => setActiveSubTab('research')}
                    >
                        <Search className="me-2" />
                        Research Notes
                    </Nav.Link>
                </Nav.Item>
            </Nav>

            {activeSubTab === 'meeting' && (
                <MeetingNotes activeProfileId={activeProfileId} />
            )}

            {activeSubTab === 'personal' && (
                <PersonalNotes activeProfileId={activeProfileId} />
            )}

            {activeSubTab === 'research' && (
                <ResearchNotes activeProfileId={activeProfileId} />
            )}
        </div>
    );
};

export default Notes;
